"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var CONSTANTS = _interopRequireWildcard(require("./constants"));

var _getChallengeTimeframeStatus = _interopRequireDefault(require("./getChallengeTimeframeStatus"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getChallengeTimeframeData = function getChallengeTimeframeData(_ref) {
  var start = _ref.start,
      end = _ref.end;
  var now = (0, _moment["default"])();
  var timeframeString = (0, _getChallengeTimeframeStatus["default"])({
    start: start,
    end: end
  });

  var duration = _moment["default"].duration(+(0, _moment["default"])(timeframeString === CONSTANTS.Status.FUTURE ? start : end) - +(0, _moment["default"])(now));

  var days = parseInt(duration.asDays().toString(), 10);
  var hours = duration.hours();
  var minutes = duration.minutes();
  var seconds = duration.seconds();
  return {
    timeframe: timeframeString,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

var _default = getChallengeTimeframeData;
exports["default"] = _default;
//# sourceMappingURL=getChallengeTimeframeData.js.map